import { useTranslation } from "react-i18next";
import "./How.scss";

export default function How() {
	const { t } = useTranslation();

	const steps = t("how.steps", { returnObjects: true });

	return (
		<section id="how" className="section">
			<div className="container">
				<h2>{t("how.title")}</h2>

				<p className="how__intro">{t("how.intro")}</p>

				<div className="steps">
					{steps.map((step, index) => (
						<div className="step" key={index}>
							<h3>{step.title}</h3>
							<p>{step.text}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
